import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { Component, Inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { FeaturesI18N } from 'controls';
import { StatusChangeNotification } from 'src/app/model/application-notification';
import { StatusColorMapper } from 'src/app/service/status-color-mapper';
import { RequestRoot } from 'types';
import { RequestFeatures } from 'src/webid/4.0/model/features';
import { RequestFeaturesV2 } from 'src/webid/4.0/model/features2';
import { RequestDataAccessService } from 'src/webid/4.0/projects/data-access/src/lib/request-data-access.service';

@Component({
    selector: 'status-change-notification',
    templateUrl: './status-change-notification.component.html',
    styleUrls: ['./status-change-notification.component.scss']
})
export class StatusChangeNotificationComponent implements OnInit {
    @Input() public notification: StatusChangeNotification | null = null;
    private request: RequestRoot | null = null;

    constructor(
        private router: Router,
        private requestService: RequestDataAccessService,
        @Inject(LOCALE_ID) private locale: string
    ) { }

    ngOnInit(): void {
        const requestRootBuffer = new RequestRoot();
        requestRootBuffer.id = this.notification?.requestId;

        this.requestService.load(requestRootBuffer).subscribe(
            (request) => this.request = request,
            (error) => console.error(error)
        )
    }

    onClick(): void {
        let params = { queryParams: { 'id': this.request?.id } };
        this.router.navigate(['/request-preview'], params);
    }

    public get uid(): string {
        return this.request?.uid ?? '';
    }

    public get fullName(): string {
        let features: RequestFeatures | RequestFeaturesV2 = this.request?.features;
        return features.applicant.personIdentity.fullName.asString();
    }

    public get status(): string {
        return FeaturesI18N.getString('STATUS.BIOPASSPORT.' + this.notification?.nextStatus);
    }

    public get color(): string {
        const nextStatus = this.notification?.nextStatus;
        return nextStatus ? `#${StatusColorMapper.getStatusColor(nextStatus).hex()}` : 'transparent';
    }

    public get created(): string {
        let date = this.notification?.created;
        let format = date && this.isToday(date) ? 'HH:mm' : 'dd.MM.yyyy';

        return date ? formatDate(date, format, this.locale) : 'Дата не указана';
    }

    private isToday(date: Date): boolean {
        let today = new Date();
        return date.getFullYear() === today.getFullYear()
            && date.getMonth() === today.getMonth()
            && date.getDate() === today.getDate();
    }
}
